<template>
  <div class="Popup-form chunky-form">
    <h2 class="acc-modal-title font-heavy">
      Please log in below
    </h2>
    <social-account-auth-buttons
      :show-text-label="false"
      :import-comment="importComment"
    />

    <div class="Authentication-divider">
      <span class="Authentication-text">
        OR
      </span>
    </div>

    <div
      v-if="serverValidationErrors.fail"
      class="Notice Notice--danger"
    >
      <div class="Notice-copy">
        {{ serverValidationErrors.fail }}
      </div>
    </div>

    <login-form
      no-redirect
      @login-form:success="setSaveItemData"
      @login-form:error="logLoginError"
    />

    <p>Don’t have an account? <strong>Register in seconds below.</strong></p>

    <button
      class="Button Button--secondary Button--long acc-register"
      @click.prevent="switchToRegister"
    >
      <span>Register for free now</span>
    </button>
  </div>
</template>

<script>

import SocialAccountAuthButtons from '@/components/authentication/common/social-account-auth-buttons';
import LoginForm from '@/components/authentication/forms/login-form';
import ModalSaveItemMixin from '@/components/modal/mixins/modal-save-item-mixin';

export default {
  components: {
    SocialAccountAuthButtons,
    LoginForm,
  },

  mixins: [ModalSaveItemMixin],
  props: {
    importComment: {
      type: String,
      default: 'modal-login-component',
    },
  },

  data() {
    return {
      success: false,
      error: false,
      loading: false,
      validateAll: false,
      serverValidationErrors: {},
    };
  },

  mounted() {
    this.$gtag.send({
      event: 'login-modal',
      action: 'show-modal',
    });
  },

  methods: {
    switchToRegister() {
      this.$bus.$emit('bus:authentication:show-register-form');
    },
    /**
     * Submits forms like a boss
     */
    setSaveItemData() {
      if (this.shortListInfo !== null) {
        this.saveItem();
      }

      this.updateAnalytics({
        event: 'login-modal',
        action: 'submit-success',
      });
      this.$bus.$emit('bus:global-modal:close');
    },

    logLoginError() {
      this.updateAnalytics({
        event: 'login-modal',
        action: 'submit-error',
      });
    },
  },
};
</script>
